import { Col, Row } from 'reactstrap';
import { clx } from 'Utils';
import { Card } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';

export const SkeletonCommissionLevel: FC = () => {
	// Inline skeleton style
	const skeletonStyle: React.CSSProperties = {
		height: '1em',
		width: '80px'
	};

	return (
		<Col>
			<Card>
				<h6 className={clx(styles.row, 'text-gray-3 fs-6 fw-400')}>
					<span className={styles.rowLabel}>
						<span
							className="skeletonStyle"
							style={skeletonStyle}></span>
					</span>
				</h6>
				<Row>
					<Col sm={12}>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}></span>
							</span>
						</div>
					</Col>
				</Row>
			</Card>
		</Col>
	);
};
